/**
 * Validates a single File against an allowed-types list and a max size (in KB).
 * Returns an error message string, or "" if the file is valid.
 */
export function validateFile(file, { allowedTypes, maxSizeKB, typesLabel }) {
  if (!file) return "";

  if (!allowedTypes.includes(file.type)) {
    return `${typesLabel} files are allowed.`;
  }

  if (file.size / 1024 > maxSizeKB) {
    const sizeLabel = maxSizeKB >= 1024 ? `${maxSizeKB / 1024} MB` : `${maxSizeKB} KB`;
    return `File size must be less than ${sizeLabel}`;
  }

  return "";
}
